// Phase G3 Stage 1b: /play/session — math practice session.
// T1.3 Phase D: skill-parameterized via ?skill=<ms.math.*> (like
// /play/foundation). Defaults to MathSession's launch_safe slice skill when
// no param, so existing no-param links keep working.
import { createFileRoute } from "@tanstack/react-router";
import { MathSession } from "@/screens/MathSession";
import { KidRouteError } from "@/components/RouterErrorFallback";

// MA-790 (f) — `seed` and `resume` validation; MA-1004 (R1) moved the
// parsers to sessionDeepLink.ts so /play/reading and /play/mixed validate
// them identically.
import { parseResumeParam, parseSeedParam } from "@/lib/engine/sessionDeepLink";

export const Route = createFileRoute("/play/session")({
  errorComponent: KidRouteError, // MA-107
  validateSearch: (search: Record<string, unknown>): { skill?: string; resume?: number; run?: string; seed?: string } => {
    // P-COACH-LOOP-FIX (Surface 2): `resume` is the item index CoachHint's
    // "Try again" resumes at (done + 1). Coerce to a non-negative integer;
    // anything else (missing, NaN, negative) drops to undefined → resume 0.
    return {
      skill: typeof search.skill === "string" && search.skill.length > 0 ? search.skill : undefined,
      resume: parseResumeParam(search.resume),
      // MA-730: the run the coach's `resume` belongs to (CoachHint carries it).
      run: typeof search.run === "string" && search.run.length > 0 ? search.run : undefined,
      // MA-790 (f): a capture replays the item order another capture read off
      // data-session-seed. Used by MathSession only when no checkpoint exists.
      seed: parseSeedParam(search.seed),
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { skill, resume, run, seed } = Route.useSearch();
  return <MathSession skillId={skill} resumeAt={resume} resumeRunId={run} seed={seed} />;
}
